import React, { useState, useRef, useEffect } from "react";
import RoleSelectionModal from "../components/RoleSelectionModal";
import { Link } from "react-router-dom";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const sidePanelRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // show on page load
  const hamburgerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sidePanelRef.current &&
        !sidePanelRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // Nav links content for reuse
  const navLinks = (
    <div className="nav-links">
      <Link to="/homepage">
        <button>Home</button>
      </Link>
      <Link to="/practitioners">
        <button>Practitioners</button>
      </Link>
      <Link to="/find-practitioners">
        <button>Find Practitioners</button>
      </Link>
      <Link to="/contact">
        <button>Contact Us</button>
      </Link>
      <button className="button-button-border">How It Works</button>
      <button
        className="button-button-login"
        onClick={() => setIsModalOpen(true)}
      >
        Login →
      </button>
      <RoleSelectionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );

  return (
    <nav className="nav">
      <div className="nav-desktop-row">
        <div className="Nav-logo">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/assets/VTLogo.png`}
              alt="VirtualTriage"
              style={{ width: "28vh" }}
            />
          </Link>
        </div>
        {navLinks}
      </div>
      <div className="navbar-hamburger" ref={hamburgerRef} onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      {/* Mobile side panel nav links */}
      <div
        className={`side-panel ${isMenuOpen ? "open" : ""}`}
        ref={sidePanelRef}
      >
        {navLinks}
      </div>
    </nav>
  );
}

export default Navbar;
